import React from "react";
import FrenteDeCaixa from "../../Components/FormFrenteDeCaixa/FormFrenteDeCaixa";

const PageFrenteDeCaixa: React.FC = () => {
  return (
    <FrenteDeCaixa/>
  );
};

export default PageFrenteDeCaixa;
